import React, { useEffect } from "react";
import Modal from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import { useRecoilValue } from "recoil";
import { resetRecoil } from "recoil-nexus";
import LogController from "../../controller/LogController";
import { useToast } from "../../controller/ToastController";
import FindItem from "../../event/FindItem";
import RandomBox from "../../event/RandomBox";
import { eventState, EventStateType } from "../../recoil/event";
import { langState, langText } from "../../recoil/lang";
import "../../styles/CustomModal.css";

const SurpriseModal = (oProps: { event: EventStateType }) => {
  const showToast = useToast();
  const lang = useRecoilValue<number>(langState);

  const onCloseModal = () => {
    resetRecoil(eventState);
  };

  useEffect(() => {
    if (oProps.event.visible && oProps.event.used > 0) {
      showToast(langText.coupon_already[lang], "error");

      LogController.click({
        path: "EventSlider",
        params: "event",
        params2: "이미 쿠폰을 발급하여 이벤트 진행불가",
        index: oProps.event.event_id!,
      });

      resetRecoil(eventState);
    }
  }, [oProps.event.visible]);

  return (
    <Modal
      open={oProps.event.visible}
      onClose={onCloseModal}
      center
      classNames={{
        overlay: "surpriseModalOverlay",
        modal: "eventGameModal",
      }}
      closeOnOverlayClick={true}
      showCloseIcon={true}
      closeIcon={
        <img
          src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_close.svg`}
          style={{ zIndex: 10, padding: "10px", paddingTop: "10px" }}
          alt="닫기 아이콘"
        />
      }
      animationDuration={150}
    >
      {/* <SnowBackground /> */}

      {oProps.event.event_type === 1 && <RandomBox />}
      {oProps.event.event_type === 2 && <FindItem />}
      {/* <RockPaperScissors /> */}
    </Modal>
  );
};

export default SurpriseModal;
